import React, { Fragment, useState, useContext, useRef } from 'react';
import Button from '../components/bronson/Button';
import Input from '../components/bronson/Input';
import Traductor from '../components/Traductor';
import LoginService from '../services/LoginService';
import UserService from '../services/UserService';
import { withRouter } from 'react-router-dom';
import ParseService from '../services/ParseService';
import { UserContext } from '../contexts/UserContext';
import { withCookies } from 'react-cookie';
import Loading from '../components/bronson/Loading';
import Globals from '../Globals';
import ReCAPTCHA from 'react-google-recaptcha';

function LoginModuleComponent({
    history,
    setRenderModuleType,
    cookies,
    handleLoginUser,
}) {
    const t = new Traductor();
    const [loginForm, setLoginForm] = useState({
        Language: 'ESP',
        UserType: '0',
        UserId: '',
        Password: '',
        Captcha: '',
    });
    const {
        setLogged,
        setUser,
        setBuyerType,
        sethasTransportAvailable,
    } = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const [loginError, setLoginError] = useState(false);
    const [captchaError, setCaptchaError] = useState(false);

    function ShowForgotPasswordForm() {
        setRenderModuleType(3);
    }

    function onChange(e) {
        if (e.target.name) {
            let newText = e.target.value;
            let inputName = e.target.name;
            newText = newText.toString().replace(' ', '');
            setLoginForm(state => ({ ...state, [inputName]: newText }));
        }
    }

    async function onSubmit(event) {
        event.preventDefault();
        setLoginForm({ ...loginForm });
        setLoginError(false);
        setCaptchaError(false);
        setLoading(true);

        if (
            captcha.current.getValue() != null &&
            captcha.current.getValue() != ''
        ) {
            loginForm.Captcha = captcha.current.getValue();
            const result = await new LoginService().doLogin(loginForm);
            if (result && result.statusCode === 200 && result.body.Result) {
                const cookieJWT = JSON.parse(result.body.Result);
                const usuarioResponse = await new UserService().getUser(
                    cookieJWT.AccessToken
                );
                if (usuarioResponse && usuarioResponse.statusCode === 200) {
                    const user = new ParseService().Parse(
                        usuarioResponse.body.Result
                    );
                    await handleLoginUser(user, cookieJWT);
                } else {
                    setLoading(false);
                    setLoginError(true);
                    captcha.current.reset();
                }
            } else {
                setLoading(false);
                setLoginError(true);
                captcha.current.reset();
            }
        } else {
            //console.log("captcha erroneo");
            setLoading(false);
            setCaptchaError(true);
            captcha.current.reset();
        }
    }

    const captcha = useRef(null);

    const onChancheCaptcha = () => {
        if (
            captcha.current.getValue() != null &&
            captcha.current.getValue() != ''
        ) {
            setCaptchaError(false);
        } else {
            setCaptchaError(true);
        }
    };

    const printCaptchaError = () => {
        let optionsCaptchaError =
            captchaError || loginError ? t.getTraduction('CaptchaError') : '';
        return optionsCaptchaError;
    };

    const printPasswordInput = () => {
        let optionsInputPassword = {
            id: 'Password',
            name: 'Password',
            type: 'password',
            className: loginError ? 'is-error' : '',
            event: true,
            label: t.getTraduction('PlaceHolderPassword'),
            autoComplete: 'true',
            link: {
                textLink: t.getTraduction('ForgotPassword'),
                onClick: ShowForgotPasswordForm,
            },
            backButton: {
                type: 'control-eye',
            },
            value: loginForm.Password,
        };

        return (
            <Input
                options={optionsInputPassword}
                onChange={e => onChange(e)}
                value={loginForm.Password}
            ></Input>
        );
    };

    const printUserIdInput = () => {
        let optionsInputUser = {
            id: 'UserId',
            name: 'UserId',
            type: 'text',
            event: true,
            label: t.getTraduction('PlaceHolderUser'),
            value: loginForm.UserId,
            className: loginError ? 'is-error' : '',
        };
        return (
            <Input
                options={optionsInputUser}
                onChange={e => onChange(e)}
                value={loginForm.UserId}
            ></Input>
        );
    };

    const printUserTypeInput = () => {
        let optionsInputUserType = {
            id: 'UserType',
            name: 'UserType',
            type: 'hidden',
            event: true,
        };

        return (
            <Input
                options={optionsInputUserType}
                onChange={e => onChange(e)}
                value={0}
            ></Input>
        );
    };

    const printSubmitButton = () => {
        let optionsBtnLogin = {
            text: t.getTraduction('Login'),
            value: 'login',
            disabled: loading ? true : false,
            class: 'u-float-right',
        };
        return <Button options={optionsBtnLogin} onClick={onSubmit}></Button>;
    };

    return (
        <Fragment>
            <div className="o-fieldset__row">
                {printUserIdInput()}
                {printUserTypeInput()}
            </div>
            <div className="o-fieldset__row">{printPasswordInput()}</div>
            <div className="o-fieldset__row">
                <ReCAPTCHA
                    ref={captcha}
                    sitekey={process.env.REACT_APP_CAPTCHA_SITEKEY}
                    onChange={onChancheCaptcha}
                />
                <div id="captchaError" style={{ color: 'red' }}>
                    {printCaptchaError()}
                </div>
            </div>
            <div className="u-flex" style={{ justifyContent: 'space-between' }}>
                <div style={{ display: 'inline-flex', alignItems: 'flex-end' }}>
                    <Button
                        options={{
                            text: t.getTraduction('Register'),
                            disabled: loading,
                            class: 'c-btn--secondary rema-stop-scrolling',
                            type: 'button',
                        }}
                        onClick={() =>
                            window.open(process.env.REACT_APP_REGISTER_URL)
                        }
                    />
                    <span className="u-text-fs-1 u-ml-small">
                        *{t.getTraduction('TraderOnly')}
                    </span>
                </div>
                {printSubmitButton()}
            </div>
            <br></br>
            <div className="rema-border-d8">
                <div className="o-fieldset__row">
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1">
                            <p className="u-h3 u-mb">AVISO IMPORTANTE</p>
                            <p className="c-form-field__label u-mb">
                                Por motivos de seguridad hemos tenido que
                                actualizar nuestra política de contraseñas. Por
                                lo tanto, a partir del día 07 de Junio (y no
                                antes) tendréis que, obligatoriamente, recuperar
                                vuestra contraseña a través del link ¿Olvidada?
                                que aparece en esta misma pantalla.
                            </p>
                            <p className="c-form-field__label u-mb">
                                Las nuevas restricciones para la contraseña son:
                            </p>
                            <ul>
                                <li>
                                    {' '}
                                    Longitud entre 12 y 20 caracteres
                                    (mayúscula, minúscula, número y símbolo)
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <Loading ariaBusy={loading}></Loading>
        </Fragment>
    );
}
export default withCookies(withRouter(LoginModuleComponent));
